import script from "./addTestDevice.vue?vue&type=script&lang=ts&setup=true"
export * from "./addTestDevice.vue?vue&type=script&lang=ts&setup=true"

import "./addTestDevice.vue?vue&type=style&index=0&id=59633620&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59633620"]])

export default __exports__